import { render, staticRenderFns } from "./FacebookButton.vue?vue&type=template&id=94975d48&scoped=true&"
var script = {}
import style0 from "./FacebookButton.vue?vue&type=style&index=0&id=94975d48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94975d48",
  null
  
)

export default component.exports